import { useLang } from "../lib/i18n";
import useReveal from "../hooks/useReveal";

export const Experience = () => {
    const { t } = useLang();
    const { ref, visible } = useReveal();

    return (
        <section
            id="experience"
            ref={ref}
            className={`relative bg-navy text-cream py-24 md:py-32 reveal ${
                visible ? "visible" : ""
            }`}
            data-testid="experience-section"
        >
            <div className="absolute inset-0 grain pointer-events-none" />
            <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 items-end">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3 text-xs tracking-[0.25em] uppercase text-cream/60">
                            <span className="inline-block w-6 h-px bg-cream/70 mr-1" />
                            {t.experience.kicker}
                        </div>
                        <h2
                            className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
                            data-testid="experience-heading"
                        >
                            {t.experience.heading}
                        </h2>
                        <div className="mt-6 h-px w-20 bg-warm" aria-hidden="true" />
                    </div>
                    <div className="md:col-span-6 md:col-start-7">
                        <p
                            className="text-cream/75 text-lg leading-relaxed"
                            data-testid="experience-copy"
                        >
                            {t.experience.copy}
                        </p>
                    </div>
                </div>

                {/* Video presentation */}
                <div className="mt-16 md:mt-20" data-testid="experience-video-wrap">
                    <div className="flex items-center gap-3 text-xs tracking-[0.25em] uppercase text-cream/60 mb-6">
                        <span className="inline-block w-6 h-px bg-warm mr-1" />
                        Video · Conóceme
                    </div>
                    <div className="relative w-full max-w-4xl mx-auto bg-navy-900 border border-cream/15 overflow-hidden shadow-[0_30px_60px_-20px_rgba(0,0,0,0.5)]">
                        <div className="aspect-video w-full">
                            <iframe
                                src="https://www.youtube.com/embed/Jr0lyT879qk?rel=0&modestbranding=1"
                                title="Gilberto Veliz — Presentación"
                                className="w-full h-full border-0"
                                loading="lazy"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                                referrerPolicy="strict-origin-when-cross-origin"
                                data-testid="experience-youtube"
                            />
                        </div>
                    </div>
                </div>

                <div
                    className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-4 border-t border-cream/20"
                    data-testid="experience-stats"
                >
                    {t.experience.stats.map((s, i) => {
                        const isRightMobile = (i + 1) % 2 === 0;
                        const isRightDesktop = i === 3;
                        return (
                            <div
                                key={i}
                                className={`py-8 md:py-10 px-4 md:px-6 border-cream/20 ${
                                    isRightMobile ? "" : "border-r"
                                } ${
                                    isRightDesktop
                                        ? "md:border-r-0"
                                        : "md:border-r"
                                } ${i < 2 ? "border-b md:border-b-0" : ""}`}
                            >
                                <div className="font-display text-5xl md:text-6xl text-cream leading-none">
                                    {i === 0 ? (
                                        <>
                                            {s.n.replace("+", "")}
                                            <span className="text-warm">+</span>
                                        </>
                                    ) : (
                                        s.n
                                    )}
                                </div>
                                <div className="mt-4 text-[10px] md:text-xs uppercase tracking-[0.2em] text-cream/60">
                                    {s.l}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Experience;
